import { useMutation } from "@tanstack/react-query";
import { useReploAgent } from "@v2/contexts/ReploAgentContext";

export function usePublish() {
  const { actions } = useReploAgent();

  const publishMutation = useMutation({
    mutationFn: async () => {
      await actions.publish();
    },
  });

  const getPublishLogsMutation = useMutation({
    mutationFn: async () => {
      return actions.getPublishLogs();
    },
  });

  return {
    publish: publishMutation.mutate,
    isPublishing: publishMutation.isPending,
    getPublishLogs: getPublishLogsMutation.mutateAsync,
    isLoadingPublishLogs: getPublishLogsMutation.isPending,
  };
}
